import Button from '../../../components/Button';
import ErrorMessage from '../../../components/ErrorMessage';
import Input from '../../../components/Input';
import Modal from '../../../components/Modal';
import Textarea from '../../../components/Textarea';

const ReportModal = ({
  isOpen,
  onCloseModal,
  isLoading,
  formik,
  saveMessage,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onCloseModal={onCloseModal}
      mainContentClassName="max-w-md modal-center"
      title="Báo lỗi dữ liệu"
      isLoading={isLoading}
      disableEscapeKeyDown={true}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full main-content">
          <div className="w-full mt-2">
            <div className="bock w-full">
              <span className="text-gray-700 dark:text-gray-400 text-sm">
                Đường dẫn(URL)
              </span>
              <Input
                formik={formik}
                placeholder="Nhập đường dẫn(URL)"
                name="url"
                defaultValue={formik.values.url || ''}
                useDebounce={false}
              />
            </div>
            <div className="bock w-full mt-1">
              <ErrorMessage
                message={
                  formik.touched.url && formik.errors.url
                    ? formik.errors.url
                    : ''
                }
              />
            </div>
          </div>

          <div className="w-full mt-2">
            <div className="block w-full">
              <span className="text-gray-700 dark:text-gray-400 text-sm">
                Mô tả
              </span>
              <Textarea
                placeholder="Nhập mô tả"
                name="description"
                formik={formik}
              />
            </div>
            <div className="block w-full mt-1">
              <ErrorMessage
                message={
                  formik.touched.description && formik.errors.description
                    ? formik.errors.description
                    : ''
                }
              />
            </div>
          </div>
          <div className="block w-full mt-5">
            <div className="block w-full">
              <Button type="submit" className="w-full">
                Báo lỗi
              </Button>
              <ErrorMessage message={saveMessage} />
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default ReportModal;
